<template> 
    <div class="lines-bg w-full py-20 lg:py-40 flex flex-wrap items-center justify-center">
    <emarsys-form :defaults="defaults" :formData="formData"  :content="{heading: 'Get All The Latest Updates <br /> and Offers from Main Event', subhead: 'You can unsubscribe at any time'}" />
  </div>
</template>

<script>
import EmarsysForm from '~/components/common/EmarsysForm'
const emarsysFields = require('~/assets/config/emarsysFormOptIn.json')

export default {
  components: {
     EmarsysForm
  },
   data() {
    return {
      page:  {},
      formData:emarsysFields,
      defaults: {
        Booking: 'event',
        ButtonName: 'Sign Up',
        RouteTo:'/eclub/thank-you'
      }
    }
  },
   beforeMount() {
    if(this.$store.state.bookDate) {
      this.defaults['Desired Date'] = this.$store.state.bookDate.format('MM/DD/YYYY')
    }
    if(this.$store.state.location) {
      this.defaults['Location'] = this.$store.state.location.centerId
    }
  }, 
  async asyncData({ $api }) {
    return {
      page: await $api.getPage('eclub')
    }
  },
  
  head: function() {
    return {
      title: `${this.page.fields.title}`
    }
  }
}
</script>



 
 